import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import client from "../lib/api";
import { Panel, StatCard, DemoTag, Spinner, fmt } from "../components/ui-kit";

export default function Analytics() {
  const [f, setF] = useState(null);
  useEffect(() => { client.get("/analytics/funnel").then(({ data }) => setF(data)); }, []);
  if (!f) return <Layout title="Analytics"><Spinner /></Layout>;
  const max = Math.max(...f.stages.map((s) => s.count));

  return (
    <Layout title="Business Analytics">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-5">
        <StatCard testid="conv-lead-click" label="Lead → Broker Click" value={`${f.conversions.lead_to_click}%`} accent="gold" />
        <StatCard testid="conv-click-verified" label="Click → Verified" value={`${f.conversions.click_to_verified}%`} accent="bull" />
        <StatCard testid="conv-free-premium" label="Free → Premium" value={`${f.conversions.free_to_premium}%`} accent="btc" />
      </div>

      <Panel title="Acquisition Funnel" right={<DemoTag />} testid="funnel-panel">
        <div className="p-4 space-y-2">
          {f.stages.map((s, i) => (
            <div key={s.stage} className="flex items-center gap-3">
              <div className="w-40 shrink-0 text-sm text-slate-400">{s.stage}</div>
              <div className="flex-1 h-8 bg-white/5 relative overflow-hidden">
                <div className="h-full flex items-center px-3 transition-all duration-500" style={{ width: `${Math.max((s.count / max) * 100, 6)}%`, background: `linear-gradient(90deg, var(--gold), rgba(212,175,55,0.4))` }}>
                  <span className="font-mono text-xs font-semibold text-black">{s.count.toLocaleString()}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Panel>
    </Layout>
  );
}
